module.exports = __webpack_public_path__ + "img/g0204.7a85da30.png";